var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCheck03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M51.3332 8.32153V23.4669C51.3332 25.5204 51.3332 26.5471 51.7328 27.3315C52.0844 28.0214 52.6453 28.5823 53.3352 28.9339C54.1196 29.3335 55.1463 29.3335 57.1998 29.3335H72.3452M32.9998 58.6666L40.3332 65.9999L56.8332 49.4999M51.3332 7.33325H32.2665C26.1059 7.33325 23.0256 7.33325 20.6726 8.53218C18.6028 9.58679 16.92 11.2696 15.8654 13.3394C14.6665 15.6924 14.6665 18.7727 14.6665 24.9333V63.0666C14.6665 69.2272 14.6665 72.3075 15.8654 74.6605C16.92 76.7303 18.6028 78.4131 20.6726 79.4677C23.0256 80.6666 26.1059 80.6666 32.2665 80.6666H55.7332C61.8938 80.6666 64.974 80.6666 67.3271 79.4677C69.3969 78.4131 71.0796 76.7303 72.1342 74.6605C73.3332 72.3075 73.3332 69.2272 73.3332 63.0666V29.3333L51.3332 7.33325Z",
    stroke: "white",
    strokeWidth: 2.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck03);
export default __webpack_public_path__ + "static/media/file-check-03.7dd9798be3187e85649d132f54419600.svg";
export { ForwardRef as ReactComponent };